import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(10),
    paddingBottom: theme.spacing(5),
    fontFamily: "Century-Gothic",
    backgroundImage:
      "linear-gradient(rgba(35, 37, 41, 0.58), rgba(35, 37, 41, 0.58)), url('/images/contact/backgroundInfoContact.jpg')",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "cover",
  },
  content: {
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(3),
  },
  paperContent: {
    height: "100%",
  },
  paperTitte: {
    background: "#33658A",
    position: "relative",
    bottom: "30px !important",
    zIndex: 2,
    marginRight: theme.spacing(5),
    marginLeft: theme.spacing(5),
    paddingBottom: theme.spacing(1),
    paddingTop: theme.spacing(1),
    borderRadius: "6px",
  },
  cardtittle: {
    marginRight: theme.spacing(3),
    marginLeft: theme.spacing(3),
    color: "white",
    fontFamily: "Century-Gothic",
    fontWeight: "bold",
  },
  papercontainer: {
    marginBottom: theme.spacing(3),
  },
  paperForm: {
    marginBottom: theme.spacing(1),
    //paddingBottom: theme.spacing(2),
    //paddingTop: theme.spacing(2),
  },
  paperFormMessage: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  paperAction: {
    marginTop: theme.spacing(3),
  },
  textListtittle: {
    color: "white",
    fontFamily: "Century-Gothic",
    fontWeight: "bold",
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(5),
    },
  },
  textList: {
    color: "white",
    fontFamily: "Century-Gothic",
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      fontSize: 20,
      marginBottom: theme.spacing(5),
    },
  },
  iconList: {
    pointerEvents: 'none',
    fontSize: 35,
    marginRight: theme.spacing(4),
    verticalAlign: "top",
    [theme.breakpoints.down("sm")]: { 
      fontSize: 30,
      marginRight: theme.spacing(1),
    },
  },
  button: {
    minWidth: 150,
    fontFamily: "Century-Gothic",
    //fontSize: 'x-large',
    backgroundColor: "#33658A",
    borderRadius: "6px",
    paddingBlockStart: "15px",
    paddingBlockEnd: "15px",
    //paddingInlineStart: '25px',
    //paddingInlineEnd: '25px',
    fontWeight: "bold",
    color: "white",
    "&:hover": {
      backgroundColor: "#33658A",
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(3),
    },
  },

  other: {
    backgroundColor: "red",
  },
}));
export default useStyles;
